import React from 'react';
import { motion } from 'framer-motion';
import Products from '../components/sections/Products';
import SEO from '../components/common/SEO';
import { Flame, Gauge, Zap, Target } from 'lucide-react';

const ProductsPage = ({ onShowDetail }) => {
  return (
    <div className="min-h-screen bg-[#0A0A0A] pt-32 pb-24 px-6 text-left">
      <SEO 
        title="Our Products" 
        description="Explore AgniThrust's premium range of bio-fuels, bio mass pellets, and bio coal. High-performance sustainable solutions for global industries."
      />
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-24"
        >
          <span className="text-primary font-bold tracking-[0.2em] mb-4 block uppercase text-sm">Industrial Catalog</span>
          <h1 className="text-2xl sm:text-4xl md:text-6xl lg:text-8xl font-black syne tracking-tighter mb-8 leading-[0.9]">
            Our High-Fuel <br />
            <span className="text-white/20 italic">Product Range.</span>
          </h1>
          <p className="text-slate-400 text-xl font-medium max-w-3xl leading-relaxed">
            Discover our premium range of bio-fuels engineered for high-performance industrial heating. We provide tailored solutions for power plants, boilers, and metallurgical processes.
          </p>
        </motion.div>

        <Products onShowDetail={onShowDetail} />

        {/* Comparison Section */}
        <div className="mt-32 p-12 md:p-24 rounded-[80px] glass border border-white/10 relative overflow-hidden group">
           <div className="absolute top-0 right-0 w-[40%] h-[40%] bg-primary/10 blur-[150px] -z-10 group-hover:bg-primary/20 transition-all"></div>
           <h2 className="text-2xl sm:text-3xl md:text-5xl font-black syne mb-8 md:mb-16 tracking-tight text-center">Fuel Comparison <br /><span className="text-slate-500 italic text-xl md:text-4xl">Engineered for Performance.</span></h2>
           
           <div className="overflow-x-auto">
             <table className="w-full text-left">
               <thead>
                 <tr className="border-b border-white/10 text-xs font-bold uppercase tracking-widest text-slate-500">
                    <th className="py-6 px-4">Parameter</th>
                    <th className="py-6 px-4">Bio Mass Pellets</th>
                    <th className="py-6 px-4">Bio Coal (Briquettes)</th>
                    <th className="py-6 px-4">Commercial Grade</th>
                 </tr>
               </thead>
               <tbody className="text-white font-medium">
                 <tr className="border-b border-white/5 hover:bg-white/5 transition-colors">
                    <td className="py-8 px-4 font-bold">Calorific Value</td>
                    <td className="py-8 px-4">4800 (Avg) kcal</td>
                    <td className="py-8 px-4">3400-4400 kcal</td>
                    <td className="py-8 px-4 text-slate-500">3500 kcal</td>
                 </tr>
                 <tr className="border-b border-white/5 hover:bg-white/5 transition-colors">
                    <td className="py-8 px-4 font-bold">Moisture Content</td>
                    <td className="py-8 px-4">&lt; 10%</td>
                    <td className="py-8 px-4">&lt; 8%</td>
                    <td className="py-8 px-4 text-slate-500">15% - 20%</td>
                 </tr>
                 <tr className="border-b border-white/5 hover:bg-white/5 transition-colors">
                    <td className="py-8 px-4 font-bold">Ash Content</td>
                    <td className="py-8 px-4">&lt; 1%</td>
                    <td className="py-8 px-4">&lt; 1.5%</td>
                    <td className="py-8 px-4 text-slate-500">Up to 4%</td>
                 </tr>
                 <tr className="border-b border-white/5 hover:bg-white/5 transition-colors">
                    <td className="py-8 px-4 font-bold">Carbon Footprint</td>
                    <td className="py-8 px-4">Neutral (99%)</td>
                    <td className="py-8 px-4">Neutral (99.5%)</td>
                    <td className="py-8 px-4 text-slate-500">High Impact</td>
                 </tr>
               </tbody>
             </table>
           </div>
        </div>

      </div>
    </div>
  );
};

export default ProductsPage;
